module.exports = __webpack_public_path__ + "img/valley-clean-air-now@3x.82ba001f.webp";